import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VEHICLE_VALUE_BEFORE_CRASH = {
  UNDER_10K: 'under_10k',
  UPPER_10k: 'upper_10k',
} as const;

export const VEHICLE_VALUE_BEFORE_CRASH_NAME = 'vehicle_value_before_crash';
export const VEHICLE_VALUE_BEFORE_CRASH_NAME_COMPLEMENTARY =
  'vehicle_value_before_crash_complementary';
interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupVehicleValueBeforeCrash: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? VEHICLE_VALUE_BEFORE_CRASH_NAME_COMPLEMENTARY
      : VEHICLE_VALUE_BEFORE_CRASH_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Na jaką kwotę ubezpieczyciel wycenił pojazd przed szkodą?'
            )}
          </FormLabel>
          <InstructionHint
            title={
              <span
                dangerouslySetInnerHTML={{
                  __html: i18n.t(
                    'Wybierz przedział, w którym znalazła się cena pojazdu (przed szkodą) według ubezpieczyciela. Zwróć uwagę, że <b>nie pytamy</b> tutaj o wycenę szkody z kosztorysu.'
                  ),
                }}
              />
            }
          />
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-vehicle-value-before-crash"
            >
              <RadioItem
                value={VEHICLE_VALUE_BEFORE_CRASH.UNDER_10K}
                label={i18n.t('Poniżej 10 000 PLN')}
                data-testid="radio-item-vehicle-value-before-crash-under-10k"
              />
              <RadioItem
                value={VEHICLE_VALUE_BEFORE_CRASH.UPPER_10k}
                label={i18n.t('Powyżej 10 000 PLN')}
                data-testid="radio-item-vehicle-value-before-crash-upper-10k"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
